// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3RADs","col":"styles_col__JtQBh"};